export enum TYPES_ACTION {
  CLIMBED = 'CLIMBED',
  LICENSE = 'LICENSE',
}

export interface IFigurantSelected {
  documents: { documentContent: string | undefined }[];
  name: string;
  model: string;
  animalBreed: string;
  id: number;
  cpf: string;
  backgroundActors: {
    isResponsible?: boolean | undefined;
    name: string;
    documents: { documentContent: string | undefined }[];
  }[];
}
